// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2OnIj","label":"SetPasswdForm_label__rplK1"};